import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isLogin: localStorage.getItem('isLogin'),
    isShow: localStorage.getItem('isLogin')
  },
  reducers: {
    loginReducer: (state, action) => {
      state.isLogin = action.payload
      return state;
    },
    isshowReducer: (state, action) => {
      state.isShow = action.payload
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { loginReducer,isshowReducer } = loginSlice.actions
export default loginSlice.reducer 
